import { call, put, all, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import {
  updateInstrumentsSuccess,
  updateInstrumentsFailure,
  updateAssetsSuccess,
  updateAssetsFailure,
  updateTagsSuccess,
  updateTagsFailure,
} from './actions';
import { boxesSuccess, boxesRequest } from '../boxes/actions';
import { UserTypes } from './types';
import { mockBoxesData } from '../../../utils/mockBoxesData';

export function* updateInstruments(action: any) {
  try {
    const { instruments } = action.payload;

    yield call(api.put, '/user', { instruments });

    yield put(updateInstrumentsSuccess(instruments));
    toast.success('Instrumentos atualizados com sucesso!');
  } catch (error) {
    console.error('Error in updateInstruments saga:', error);
    yield put(updateInstrumentsFailure());
    toast.error('Erro ao atualizar instrumentos. Tente novamente.');
  }
}

export function* updateAssets(action: any) {
  try {
    const { assets } = action.payload;

    yield call(api.put, '/user', { assets });

    yield put(updateAssetsSuccess(assets));
    toast.success('Ativos atualizados com sucesso!');
  } catch (error) {
    console.error('Error in updateAssets saga:', error);
    yield put(updateAssetsFailure());
    toast.error('Erro ao atualizar ativos. Tente novamente.');
  }
}

export function* completeTourSaga() {
  try {
    yield call(api.post, '/onboarding/completeTour');
  } catch (error) {
    console.error('Error completing tour:', error);
  }
}

export function* loadDemoDataSaga() {
  try {
    yield call(api.post, '/onboarding/loadDemoData');
    yield put(boxesSuccess(mockBoxesData));
    toast.success('Dados de demonstracao carregados!');
  } catch (error) {
    toast.error('Erro ao carregar dados de demonstracao.');
  }
}

export function* updateTags(action: any) {
  try {
    const { tags } = action.payload;

    yield call(api.put, '/user', { tags });

    yield put(updateTagsSuccess(tags));
    toast.success('Tags atualizadas com sucesso!');
  } catch (error) {
    console.error('Error in updateTags saga:', error);
    yield put(updateTagsFailure());
    toast.error('Erro ao atualizar tags. Tente novamente.');
  }
}

export function* clearDemoDataSaga() {
  try {
    yield call(api.post, '/onboarding/clearDemoData');
    yield put(boxesRequest());
    toast.success('Dados de demonstracao removidos!');
  } catch (error) {
    toast.error('Erro ao remover dados de demonstracao.');
  }
}

export default all([
  takeLatest(UserTypes.UPDATE_INSTRUMENTS_REQUEST, updateInstruments),
  takeLatest(UserTypes.UPDATE_ASSETS_REQUEST, updateAssets),
  takeLatest(UserTypes.UPDATE_TAGS_REQUEST, updateTags),
  takeLatest(UserTypes.COMPLETE_TOUR, completeTourSaga),
  takeLatest(UserTypes.LOAD_DEMO_DATA, loadDemoDataSaga),
  takeLatest(UserTypes.CLEAR_DEMO_DATA, clearDemoDataSaga),
]);
